import React from 'react';
import { notices, schedule } from '../data/business';
import { GoldDivider } from './GoldDivider';
import { PhoneButton } from './PhoneButton';
export function SiteFooter() {
  const today = new Date().getDay();
  return <footer id="hours" className="w-full bg-night" data-id="element-61" data-mp="3mg86610ozsx9">
      <div className="wrap pb-[clamp(3rem,3.5vw,8rem)]" data-id="element-62" data-mp="3hig1e6ey8cbn">
        <GoldDivider data-id="element-63" data-mp="3hhwudkqu78ce" />
      </div>
      <div className="bg-panel" data-id="element-64" data-mp="3hglp1ghqtsj6">
        <div className="h-0.5 w-full bg-gold-gradient" aria-hidden="true" data-id="element-65" data-mp="3dh4kcpa54zf2" />
        <div className="wrap grid grid-cols-1 gap-[clamp(2.5rem,4vw,10rem)] py-[clamp(3.5rem,4.5vw,11rem)] md:grid-cols-[1.4fr_1fr_1fr]" data-id="element-66" data-mp="38i1ex3q90r6k">
          <div className="min-w-0" data-id="element-67" data-mp="33jgeb37345hl">
            <p className="fs-h2 text-gold-gradient inline-block pb-[0.05em] font-display font-bold leading-tight" data-id="element-68" data-mp="33krk18k3bnbc">
              ¿Tienes hambre?
            </p>
            <p className="fs-lg mt-[0.4em] text-muted" data-id="element-69" data-mp="11q0na5734om3">Hungry? Give us a call — we'll get it going.</p>
            <PhoneButton size="lg" className="mt-[clamp(1.25rem,1.6vw,3.5rem)]" data-id="element-70" data-mp="wtijp8nhqwbc" />
          </div>

          <div className="min-w-0" data-id="element-71" data-mp="15q2bysvzvcbb">
            <h2 className="fs-card-title text-gold-gradient inline-block font-display font-bold leading-tight" data-id="element-72" data-mp="15t81284mie71">
              Horario
            </h2>
            <dl className="fs-sm mt-[1em] space-y-[0.25em]" data-id="element-73" data-mp="vtqulohjrwa0">
              {schedule.map(s => {
              const isToday = s.days.includes(today);
              return <div key={s.day} className={`-mx-[0.85em] flex justify-between gap-[1em] rounded-[0.6em] px-[0.85em] py-[0.4em] font-label uppercase tracking-[0.12em] ${isToday ? 'bg-gold-light/10 text-gold-light' : ''}`} data-id="element-74" data-mp="1ogtilmolkom0">
                    <dt className={isToday ? '' : 'text-muted'} data-id="element-75" data-mp="1jpbnhf999i8y">
                      {s.day}
                      {isToday && <span className="sr-only" data-id="element-76" data-mp="27enzsnzvq6fh"> (today)</span>}
                    </dt>
                    <dd className={isToday ? 'font-medium' : 'text-cream'} data-id="element-77" data-mp="2c7peow0365z2">{s.hours}</dd>
                  </div>;
            })}
            </dl>
          </div>

          <div className="min-w-0" data-id="element-78" data-mp="2h3l2piijk9bc">
            <h2 className="fs-card-title text-gold-gradient inline-block font-display font-bold leading-tight" data-id="element-79" data-mp="2h4mfbrf7h3v6">
              Good to know
            </h2>
            <ul className="fs-sm mt-[1em] space-y-[0.7em] leading-relaxed text-muted" data-id="element-80" data-mp="283ochcgi72e6">
              {notices.map(n => <li key={n} data-id="element-81" data-mp="234trq4yz73rf">{n}</li>)}
            </ul>
          </div>
        </div>
        <div className="border-t border-gold/15" data-id="element-82" data-mp="1ycjvk779p7gp">
          <p className="wrap fs-xs py-[clamp(1.25rem,1.4vw,3rem)] font-label uppercase tracking-[0.18em] text-muted" data-id="element-83" data-mp="1te8mhyosr0zj">
            © {new Date().getFullYear()} Oh My Tacos · ¡Buen provecho!
          </p>
        </div>
      </div>
    </footer>;
}